module.exports = __webpack_public_path__ + "img/check-box.88d016bf.svg";